import * as Analysis from '../../../services/AnalysisService';

export const CREATE_QUESTION_MAP = 'CREATE_QUESTION_MAP';
export const SET_DISPLAY_QUESTION_MAP = 'SET_DISPLAY_QUESTION_MAP';

// ACTION GENERATORS
const createQuestionMapAction = (questions, containerId) => ({
    type: CREATE_QUESTION_MAP,
    payload: Analysis.createQuestionMap(questions, containerId),
});

const setDisplayQuestionMapAction = display => ({
    type: SET_DISPLAY_QUESTION_MAP,
    payload: display,
});

// EXPORT ACTIONS
export {
    createQuestionMapAction as createQuestionMap,
    setDisplayQuestionMapAction as setDisplayQuestionMap,
};
